<template>
    <aside class="border" style="min-height: 100vh; width: 250px; position: fixed;">
        <div class="text-center mt-4">
            <img src="@/assets/logo.png" style="width: 200px;" />
        </div>
        
        <ul class="">
            <li class="btn btn-primary">
                <RouterLink to="/admin/reservas">
                    Reservas
                </RouterLink>
            </li>
            <li class="btn btn-primary">
                <RouterLink to="/admin/fechas">
                    Fechas
                </RouterLink>
            </li>
            <li class="btn btn-primary">
                <RouterLink to="/admin/precios">
                    Precios
                </RouterLink>
            </li>
            <li class="btn btn-primary">
                <RouterLink to="/admin/galeria">
                    Secciones
                </RouterLink>
            </li>
        </ul>
    </aside>
</template>

<script>
export default {
    name: 'ComponentNavbarAdmin',
    mounted() {

    },
    data() {
        return {

        };
    },
    methods: {

    },

};
</script>

<style scoped>
ul {
    list-style: none;
    /* Quita los puntos de los <li> */
    padding: 0;
    margin: 0;
}

li {
    margin-top: 15px;
    padding: 5px;
    width: 120px;
    display: blocK;
    margin-left: auto;
    margin-right: auto;
}

a {
    text-decoration: none; /* Quita el subrayado */
    color: inherit; /* Hereda el color del contenedor */
}

a:visited {
    color: inherit; /* Evita que cambie el color después de visitar */
}

a:hover {
    text-decoration: none; /* Asegura que no aparezca subrayado en hover */
}

</style>